/** @jsxImportSource theme-ui */
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import { ThemeUIStyleObject } from 'theme-ui';

import { locationWithinPath } from 'utils/routerUtils';

import { BdIcon } from 'components/_common/BdIcon';
import BdBetaPill from 'components/_common/BetaNotifications/BdBetaPill/BdBetaPill';
import { Typography } from 'components/_common/Typography';

import { NavigationbarUrl } from '../Navigationbar';

const Styles: ThemeUIStyleObject = {
  height: '100%',
};

type NavbarItemProps = {
  options: NavigationbarUrl;
  onClick?: (url: string) => void;
};

const NavbarItem: React.FC<NavbarItemProps> = ({ options, onClick }) => {
  const { pathname } = useLocation();

  const isLink = !!options.routerLink?.length;

  const handleClick = () => {
    options.onClick && options.onClick();
    onClick && onClick(options.routerLink);
  };

  const menuItem = (
    <Menu.Item
      as="div"
      className="menu-item"
      active={locationWithinPath(pathname, options.routerLink)}
      onClick={handleClick}
      sx={Styles}
    >
      {options.icon != null ? (
        <BdIcon name={options.icon} color="inherit" className="display circle-mask" />
      ) : (
        <Typography variant="body2" className="display" marginBottom="0px">
          {options.title}
        </Typography>
      )}
      {options.isBeta && <BdBetaPill />}
    </Menu.Item>
  );

  return isLink && options.isExternalLink ? (
    <a href={options.routerLink}>{menuItem}</a>
  ) : isLink ? (
    <Link to={options.routerLink}>{menuItem}</Link>
  ) : (
    menuItem
  );
};

export default NavbarItem;
